import React, { useCallback, useState } from "react";
import PlantAlertsList from "./PlantAlertsList";
import PlantList from "./PlantList";
import AlertDefinition from "./alert-definitions/AlertDefinition";
import './CustomAlertManager.css';
import { Col, Row, View } from "@woodmac-hycb/layout";
import AlertsPlot from "./AlertsPlot";
import Header from "./Header";
import useErrorHandling from '../hooks/UseErrorHandling';
import axios from 'axios';
import ErrorModal from "./ErrorModal";

// Create the function
export function AddLibrary(urlOfTheLibrary) {
    const script = document.createElement("script");
    script.src = urlOfTheLibrary;
    script.async = true;
    document.body.appendChild(script);
}

function CustomAlertManager() {

    const [selectedPlant, setSelectedPlant] = useState(null);
    const [alertsToPlot, setAlertsToPlot] = useState([]);
    const [newAlert, setNewAlert] = useState(null);
    const [selectedAlert, setSelectedAlert] = useState(null);
    const { showErrorModal, errorModalVisible, closeErrorModal, errorMessage } = useErrorHandling();


    axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if (error.response.status !== 409) {
            showErrorModal(error.message)
        }
    });

    const setSelected = useCallback((plant) => {
        setSelectedPlant(plant);
        setAlertsToPlot([]);
    }, [setSelectedPlant, setAlertsToPlot]);

    const SetPlottedAlerts = useCallback((alerts) => {
        setAlertsToPlot(alerts);
    }, [setAlertsToPlot]);

    return (
        <View>
            <Header />
            {/* Call the function to add a library */}
            {AddLibrary("../../applicationSettings.local.js")}
            <View margin={64}>
                <Col gap={32}>
                    <Row gap={32}>
                        <PlantList SetSelectedPlant={setSelected}></PlantList>
                        <PlantAlertsList selectedPlant={selectedPlant} setPlottedAlerts={SetPlottedAlerts} alertToAdd={newAlert} setSelectedAlert={setSelectedAlert}></PlantAlertsList>
                    </Row>
                    <Row gap={32}>
                        <AlertDefinition selectedPlant={selectedPlant} addNewAlert={setNewAlert} selectedAlert={selectedAlert}></AlertDefinition>
                        <AlertsPlot alertsToPlot={alertsToPlot} selectedPlant={selectedPlant}></AlertsPlot>
                    </Row>
                </Col>
            </View>
            {errorModalVisible && <ErrorModal isOpen={errorModalVisible} onClose={closeErrorModal} errorMessage={errorMessage} />}
        </View>
    );

}

export default CustomAlertManager